export const ratingRequest = ({
    content,
    star,
    productId,
    userId,
    orderDetailId
} = {}) => ({
    content,
    star,
    productId,
    userId,
    orderDetailId
})